/**
 *  Component - Checkbox
 *
 *  @param { label } checkbox label
 *  @param { disable } boolean value to disable
 *  @param { checked } boolean value to check
 *
 * Usage:
 * <!--
 * <tl-checkbox label="EPS number same as PF number" v-model="sameAsPF"></tl-checkbox>
 *   -->
 *
 */
<template>
  <div class="tl-checkbox">
    <label class="container" :class=" { 'disable': disable }">{{label}}
      <input type="checkbox"
        v-bind:disabled = "disable"
        v-bind:checked="checked"
        v-on:change="$emit('change', $event.target.checked)">
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'tl-checkbox',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    'checked': Boolean,
    'disable' : Boolean,
    'label': String
  }
}
</script>

<style lang="scss" scoped>
.container {
  &.disable{
    opacity: 0.5;
  }
}
</style>
